export default "__VITE_ASSET__C3wfkR8r__"